module.exports = __webpack_public_path__ + "static/media/6D.416478dd.svg";